module.exports = __webpack_public_path__ + "img/newbie-gray.3203888b.svg";